<template>
  <div class="main">
    <div id="particles"></div>
    <!-- <vue-canvas-nest :config="config" :el="'#area'"> 
    </vue-canvas-nest> -->
    <el-row type="flex" align="center" justify="center" class="opc">
      <el-col :span="24" style="font-size: 0">
        <el-image
          style="width:100%;height:100vh"
          :src="require('assets/images/background.jpg')"
          fit="cover"
        ></el-image>
      </el-col>
    </el-row>
    <div class="fixed">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h2>登录</h2>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm wid" @keydown.enter.native="submitForm('ruleForm')">
          <el-form-item label="用户名" prop="name">
            <el-input type="name" v-model="ruleForm.name" autocomplete="off" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pword">
            <el-input type="password" v-model="ruleForm.pword" autocomplete="off" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
// import vueCanvasNest from 'vue-canvas-nest'
// import particles from 'particles.js'
import particlesJson from 'assets/utils/particles.json'
export default {
  name: 'login',
  components: {
    // vueCanvasNest
  },
  data() {
    var username = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('用户名不能为空'))
      }
      callback()
    }
    var password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      }
      callback()
    }
    return {
      config: {
        color:'254,73,2',
        pointColor: '255,255,255',
        count: 99,
        zIndex: 9
      },
      ruleForm: {
        name: '',
        pword: ''
      },
      rules: {
          name: [
            { validator: username, trigger: 'blur' }
          ],
          pword: [
            { validator: password, trigger: 'blur' }
          ]
        }
    }
  },
  mounted(){
    // this.$nextTick(() => {
    //   this.initParticlesJS()
    // })
    particlesJS('particles',particlesJson);
  },
  methods: {
    submitForm(formName) {
        let params = {
          userName: this.ruleForm.name,
          passWord: this.ruleForm.pword
        }
        this.$store.state.userInfo = params
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$request({
              url: '/api/user/doLogin',
              method: 'post',
              data: params
            }).then((res) => {
              // console.log(res)
              if(res.data.code === 200) {
                this.$store.commit('setRole', res.data.data.rid)
                this.$store.commit('setToken', res.data.data.user_info)
                this.$router.replace('/home')
                this.$message({
                  // title: '登录成功',
                  message: '欢迎进入统一登录平台！',
                  offset: 50,
                  duration: 2000,
                  type: 'success'
                })
              } else {
                this.$refs[formName].resetFields()
                this.$message.error({
                  // title: '登录失败',
                  message: '请输入正确的用户名和密码！',
                  offset: 50,
                  duration: 2000
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
  }
}
</script>

<style lang="less" scoped>
#particles{
      position: fixed;
      width: 100%;
      height: 100%;
      // background-color: url('../../assets/images/bg.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      z-index: 5;
}

// .opc {
//   opacity: .9;
// }
.main {
  width: 100%;
  height: 100vh;
  .fixed {
    // opacity: 0.1;
    position: fixed;
    top: 30%;
    right: 100px;
    // transform: translateY(-50%);
    z-index: 9;
    // background: #fff;
    // padding: 15px 45px 15px 15px;
    .wid {
      width: 20vw;
    }
    h2 {
      margin: 5px 0 5px 13px;
    }
  }
}
</style>